import { CLEAR_PAGE } from '../base/types';
import { FETCH_SINGLE_PAGE } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: {}
};

const pagesReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_SINGLE_PAGE}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_SINGLE_PAGE}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_SINGLE_PAGE}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'singlePage' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default pagesReducer;
